<template>
    <div class="languages">
        <multiselect v-model="lang"
                     :options="languages"
                     :searchable="false"
                     :close-on-select="true"
                     :show-labels="false"
                     :allow-empty="false"
                     @select="changeLang"
        ></multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    const isDemo = location.host === 'demo.sourcelms.com';

    export default {
        components: {
            Multiselect
        },
        data() {
            return {
                lang: localStorage.getItem('language') ? localStorage.getItem('language') : isDemo ? 'en' : 'ua',
                languages: ['ua', 'ru', 'en', 'de', 'it', 'es', 'fr', 'pl'],
                langInfo: [
                   { id: 1, name: "ru" },
                   { id: 2, name: "ua" },
                   { id: 3, name: "en" },
                   { id: 4, name: "de" },
                   { id: 5, name: "it" },
                   { id: 6, name: "es" },
                ],
            }
        },
        computed: {
            currentRouteBase() {
                return location.host === 'demo.sourcelms.com'
            },
        },
        methods: {
            changeLang(selectedOption) {
                localStorage.setItem('language', selectedOption);
                
                // const searchByName = (lang) => lang.name === selectedOption;
                // const lang = this.langInfo.find(searchByName);

                // if (lang === undefined) return;

                // this.$store.dispatch('changeLanguage', lang.id)
                //     .then(() => {
                //         localStorage.setItem('language', selectedOption);
                //         document.location.reload();
                //     });

                // localStorage.setItem('language', selectedOption);
                this.$locale = selectedOption;
            }
        }
    }
</script>
